import { Tooltip } from '@mui/material';

const FIXED_TOOLTIP_DELAY_MS = 200;
const HOVER_TOOLTIP_DELAY_MS = 400;

type NavbarTooltipProps = {
  title: string;
  subTitle?: string;
  isExpanded: boolean;
  isHoverExpanded?: boolean;
  isNew?: boolean;
  children: any;
  disabled?: boolean;
};

const NavbarTooltip = ({
  children,
  subTitle,
  isExpanded,
  isHoverExpanded,
  disabled,
}: NavbarTooltipProps) => {
  const tooltipDelayMs = isHoverExpanded
    ? HOVER_TOOLTIP_DELAY_MS
    : FIXED_TOOLTIP_DELAY_MS;

  return (
    <Tooltip
      enterDelay={tooltipDelayMs}
      disableHoverListener={disabled}
      disableFocusListener={disabled}
      disableTouchListener={disabled}
      title={isExpanded && subTitle ? subTitle : ''}
      placement="right"
      TransitionProps={{ exit: false }}
      PopperProps={{
        sx: { pointerEvents: 'none' },
      }}
    >
      {children}
    </Tooltip>
  );
};

export default NavbarTooltip;
